<template>
  <div class="address-disclosure">
    <div class="container">
      <div class="header-section">
        <h1 class="title">{{ translateTitle("88钱包地址披露及储备证明更新") }}</h1>
        <p class="description">
          {{ translateTitle("始终致力于在生态系统内建立透明度和信任，为此，我们将公开平台的热钱包和冷钱包地址。这仅仅是一个开始——我们的目标是为用户提供信息，以便他们能够根据自己的财务目标做出明智的决策。") }}
        </p>
      </div>
      
      <div class="table-section">
        <el-table
          :data="addressData"
          :border="true"
          :header-cell-style="{ backgroundColor: '#202630', color: '#ffffff', textAlign: 'left' }"
          :cell-style="{ textAlign: 'left' }"
          class="address-table"
        >
          <el-table-column 
            prop="coin" 
            :label="translateTitle('链')" 
            width="200"
          ></el-table-column>
          <el-table-column 
            prop="currency"
            :label="translateTitle('币种')"
            width="160"
          ></el-table-column>
          <el-table-column 
            prop="address" 
            :label="translateTitle('钱包地址')"
            min-width="400"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="address-cell">
                <span class="address-text">{{ scope.row.address }}</span>
                <el-button
                  type="text" 
                  size="mini"
                  @click="copyAddress(scope.row.address)"
                  class="copy-btn"
                >
                  {{ translateTitle("复制") }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { translateTitle } from "@/assets/js/i18n";

export default {
  name: 'AddressDisclosure',
  data() {
    return {
      addressData: [
        { coin: 'ERC20', address: '0x2b1598afb3b55f4ca948467980e04c10b1ee9a27', currency: 'USDT' },
        { coin: 'ERC20', address: '0x83bd3fa4a65b0f6b4ba594b7c9254e75e54b1080', currency: 'USDT' },
        { coin: 'ERC20', address: '0x2801f43c217e617b30ac60a49f621be8fddfc055', currency: 'USDT' },
        { coin: 'ERC20', address: '0xf41003be81c96a2877a1ce1adc0325a8e16d6e54', currency: 'USDT' },
        { coin: 'ERC20', address: '0xf49644de334b7fd51e28242572d353f927f57ad0', currency: 'USDT' },
        { coin: 'TRC20', address: 'TXNwMVtwTaxZoMVh8zwLm6YNQAhnb3gSMH', currency: 'USDT' },
        { coin: 'TRC20', address: 'TDSyCNBy7pheuyYiveyEJdESbR2EaNVZEA', currency: 'USDT' },
        { coin: 'TRC20', address: 'TJm5Td34FeUi9aM7XghCTdY69xteUyrtWL', currency: 'USDT' },
        { coin: 'TRC20', address: 'TYvzc8vd1VvGj2ZYdTiLApdTiRotXwegHC', currency: 'USDT' },
        { coin: 'TRC20', address: 'TBaahJjvCH6ihoLfQHxZSsHd3Bdxmongqy', currency: 'USDT' },
        { coin: 'TRC20', address: 'THkRYL32Qx5o95GUBC37neKCqr6jB8n8pV', currency: 'TRX' },
        { coin: 'DOGE', address: 'DHdiFnjJmXmUNJz4VKi1st9VE9PYmdaG2G', currency: 'DOGE' },
        { coin: 'BSC', address: '0xd012bd089843a1ca3e296c7daf7fed9983162105', currency: 'BNB' },
        { coin: 'HECO', address: '0x4c612055136a8a87bc535c57c32d2d2fb572c533', currency: 'USDT' },
        { coin: 'BSC', address: '0xe0618d384e26f318675349003ffd9f568f1c1de3', currency: 'USDT' },
        { coin: 'BSC', address: '0xb9c823107a25b95d38a7e87dd40f24a06b496f86', currency: 'USDT' },
        { coin: 'BSC', address: '0x8d7947af3ef2da9c8c8b5ba5811d0bb19fd53598', currency: 'USDT' },
        { coin: 'BSC', address: '0x7c11782d87f6ec994a4b23a8c8e06e0c6007ac0f', currency: 'USDT' },
        { coin: 'BSC', address: '0x7904f7c3744664429f16df48a1a67d2d1c770051f', currency: 'USDT' },
        { coin: 'BSC', address: '0xe0618d384e26f318675349003ffd9f568f1c1de3', currency: 'SOL' },
        { coin: 'BSC', address: '0xecdbf6e6b4290f2700f83508a5a8123ddaa62e65', currency: 'SOL' },
        { coin: 'BSC', address: '0xf15861af9a9ac3e953138698ecd800a6510ae8df', currency: 'ETH' },
        { coin: 'BSC', address: '0xe0618d384e26f318675349003ffd9f568f1c1de3', currency: 'ETH' },
        { coin: 'BSC', address: '0x052bd1b0ae0a166b85f7cf46235dc3dc758201df', currency: 'BTC' },
        { coin: 'BSC', address: '0xe0618d384e26f318675349003ffd9f568f1c1de3', currency: 'BTC' },
        { coin: 'SOL', address: '5CKN5eNyVTMX2sayfUSqfAkPknaSkaaMdzbVAmbhiyb', currency: 'USDT' },
        { coin: 'ERC20', address: '0x2c5158501092d8b5d87cbe69332d0f3759e8df75', currency: 'ETH' },
        { coin: 'ERC20', address: '0x223cc748e7b82c5ea94c05daae8bef2a2a5c05fc', currency: 'ETH' },
        { coin: 'OMNI', address: '1E5VyebxZ5ZhK2Up1EndZ7T1cb7bK8fFFyJ', currency: 'BTC' },
        { coin: 'OMNI', address: '14pF531JPDakByXiEyNREYF4NLP8A7RaHM', currency: 'BTC' }
      ]
    }
  },
  methods: {
    translateTitle,
    copyAddress(address) {
      this.$copyText(address).then(() => {
        this.$message({
          type: 'success',
          message: this.translateTitle('内容复制成功')
        })
      }).catch(() => {
        this.$message({
          type: 'error', 
          message: this.translateTitle('内容复制失败')
        })
      })
    }
  },
  metaInfo: {
    title: '地址披露 - 88交易所'
  }
}
</script>

<style lang="scss" scoped>
.address-disclosure {
  min-height: 100vh;
  // background-color: #f8f9fa;
  background-color: #fff;
  padding: 40px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    // background-color: #ffffff;
    // border-radius: 8px;
    // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    // overflow: hidden;
  }

  .header-section {
    padding: 40px;
    text-align: left;

    .title {
      // font-size: 24px;
      // font-weight: bold;
      // margin-bottom: 16px;
      // color: #333;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 32px;
      color: #202630;
    }

    .description {
      // font-size: 16px;
      // line-height: 1.5;
      // color: #666;
      // margin-bottom: 0;

      /* 始终致力于在生态系统内建立透明度和信任，为此，我们将公开平台的热钱包和冷钱包地址。这仅仅是个开始——我们的目标是为用户提供信息，以便他们能够根据自己的财务目标做出明智的决策。 */
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 24px;
      color: #202630;
      margin: 50px 0 0 0;
    }
  }

  .table-section {
    padding: 0 40px;

    .address-table {
      width: 100%;

      ::v-deep .el-table__header th {
        background-color: #2f3349 !important;
        color: #ffffff !important;
        font-weight: 600;
        font-size: 16px;
      }

      ::v-deep .el-table__row {
        &:nth-child(even) {
          background-color: #f8f9fa;
        }

        &:hover > td {
          background-color: #e3f2fd !important;
        }
      }

      ::v-deep .el-table td {
        padding: 15px 0;
        font-size: 14px;
      }

      .address-cell {
        display: flex;
        align-items: left;
        justify-content: space-between;
        padding: 0 15px;

        .address-text {
          font-family: 'Courier New', monospace;
          font-size: 13px;
          color: #333;
          word-break: break-all;
          flex: 1;
          padding-right: 10px;
        }

        .copy-btn {
          color: #409eff;
          font-size: 12px;
          padding: 0;
          min-width: 40px;
          
          &:hover {
            color: #66b1ff;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .address-disclosure {
    padding: 20px 10px;

    .header-section {
      padding: 20px;

      .title {
        font-size: 20px;
      }

      .description {
        font-size: 14px;
      }
    }

    .table-section {
      padding: 20px;
    }

    .address-table {
      ::v-deep .el-table__header th {
        font-size: 14px;
      }

      .address-cell {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;

        .address-text {
          padding-right: 0;
        }
      }
    }
  }
}
</style>